<template>
  <div class="row">
    <PublicHeader :title="'Dados por secretaria'">
      <div class="col-xs-12">
        <p>
          Aqui você encontra a lista de dados, vinculados com as Secretarias
          Municipais e/ou Fundações e Autarquias.
        </p>
      </div>
    </PublicHeader>
    <div class="container">
      <Breadcrumb :links="[{ label: 'Dados por Secretaria' }]" />
      <div class="row">
        <div class="col-xs-12">
          <a role="button" class="text-2xl" @click="abrir()">
            Adicionar filtros
            <font-awesome-icon :icon="'plus'" class="text-xl" />
          </a>
        </div>
      </div>
      <CardsFiltrosSecretaria
        v-if="secretariasFiltradas.length"
        :secretarias="secretariasFiltradas"
        @click="removerFiltro"
      />
      <div class="row">
        <div class="col col-xs-10">
          <h3>Digite sua pesquisa</h3>
        </div>
        <div class="col-xs-12">
          <div class="input-group filtro-pesquisa">
            <input
              type="text"
              class="form-control"
              v-model="filtros.termo_pesquisa.codigo"
              placeholder="Filtrar pesquisa..."
            />
            <span class="input-group-btn">
              <button
                class="btn btn-default"
                @click="add('termo_pesquisa', filtros.termo_pesquisa)"
              >
                <font-awesome-icon :icon="'search'" />
              </button>
            </span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <h3>Lista de dados</h3>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <data-table-public
            ref="dt"
            :has-auth="false"
            title="lista de dados"
            api-url="listar-dados"
            :show-empty="true"
            :fields="model.columns"
            :append-params="filtrosParametro"
          >
            <template slot="icon" slot-scope="props">
              <a role="button" @click="salvarFavorito(props.rowData.codigo)">
                <font-awesome-icon
                  :icon="classeFavoritos(props.rowData.codigo)"
                >
                </font-awesome-icon>
              </a>
            </template>
            <template slot="rowrender" slot-scope="props">
              <router-link
                title="Listar valores"
                class="btn btn-primary"
                :to="{
                  name: 'public_detalhes',
                  params: { id: props.rowData.codigo },
                  query: { origem: 'dados-secretaria' }
                }"
              >
                <font-awesome-icon :icon="'list-ol'" />
              </router-link>
              <button
                :class="['btn', classeSelecionados(props.rowData.codigo)]"
                @click="toggleAddDado(props.rowData.codigo)"
                title="Dado Comparativo"
                :data-toggle="'popover'"
                :data-content="getPopoverContent(props.rowData.codigo)"
                :data-placement="'top'"
                :data-trigger="'hover'"
              >
                <font-awesome-icon
                  :icon="addDadoState[props.rowData.codigo] ? 'minus' : 'plus'"
                />
              </button>
            </template>
          </data-table-public>
        </div>
      </div>
    </div>
    <side-bar :sides="[...nav]">
      <template :slot="nav.identidade">
        <div class="side-body">
          <div class="row">
            <div class="col-xs-12">
              <a
                v-for="secr in secretariasNaoFiltradas"
                role="button"
                class="link-filtro text-lg"
                :title="secr.titulo"
                :data-toggle="'popover'"
                :data-content="secr.objetivo"
                :data-trigger="'hover'"
                :key="secr.codigo"
                @click="addFiltro(secr.codigo)"
              >
                <font-awesome-icon :icon="'plus'" />
                <span> {{ secr.sigla }} - {{ secr.nome }} </span>
              </a>
            </div>
          </div>
        </div>
      </template>
    </side-bar>
    <FaixaComparacao :idsArray="idsArray" :query="'dados-secretaria'" />
  </div>
</template>

<script>
import {
  PublicHeader,
  Breadcrumb,
  DataTablePublic,
  CardsFiltrosSecretaria,
  SideModal as SideBar,
  FaixaComparacao
} from '@/components'
import { request } from '@/request'
import { formatObjectToQueryString } from '@/utils/strings'

export default {
  components: {
    PublicHeader,
    Breadcrumb,
    DataTablePublic,
    CardsFiltrosSecretaria,
    SideBar,
    FaixaComparacao
  },
  data() {
    return {
      addDadoState: {},
      nav: {
        titulo: 'Filtros',
        subtitulo: 'Selecione as secretarias desejadas',
        subtDetalhe: '',
        largura: 1200,
        identidade: 'filtro-secretaria',
        abreProximo: true,
        aberto: false
      },
      title: 'Dados',
      filtros: {
        secretarias: [],
        autarquias: [],
        termo_pesquisa: {
          codigo: '',
          ativo: true
        }
      },
      model: {
        columnID: 'DAD_IDDADP',
        columns: [
          {
            name: 'nome',
            title: 'Nome',
            dataClass: 'align-middle',
            filterable: true
          },
          {
            name: 'fonte',
            title: 'Fonte',
            dataClass: 'align-middle',
            filterable: true
          },
          {
            name: '__slot:icon',
            title: 'Favoritos',
            titleClass: 'text-center',
            dataClass: 'align-middle text-center'
          },
          {
            name: '__slot:actions',
            title: 'Ações',
            titleClass: 'text-center col-md-3',
            dataClass: 'text-center'
          }
        ]
      },
      filtrosParametro: { secretarias: [] }
    }
  },
  created() {
    this.formatQueryParams()
  },
  mounted() {
    this.loadFiltros()
  },
  methods: {
    classeSelecionados(codigo) {
      return this.addDadoState[codigo] ? ['btn-remove'] : ['btn-add']
    },
    getPopoverContent(codigo) {
      return this.addDadoState[codigo]
        ? 'Clique para remover o dado da comparação'
        : 'Clique para adicionar o dado para comparação'
    },
    toggleAddDado(codigo) {
      if (this.addDadoState[codigo] === undefined) {
        this.$set(this.addDadoState, codigo, true)
      } else {
        this.addDadoState[codigo] = !this.addDadoState[codigo]
      }
    },
    abrir() {
      this.nav.titulo = 'Filtros'
      this.$emit('abreModal', this.nav.identidade)
    },
    addFiltro(codigo) {
      this.filtrosParametro.secretarias.push(codigo)
      this.$refs.dt.refresh()
    },
    removerFiltro(secretaria) {
      const filter = secr => {
        return secr !== secretaria.codigo
      }

      this.filtrosParametro.secretarias = this.filtrosParametro.secretarias.filter(
        filter
      )

      this.$refs.dt.refresh()
    },
    formatQueryParams() {
      const { query } = this.$router.history.current
      const { secretarias, autarquias } = query
      const getValues = item => (isNaN(item) ? 0 : Number(item))

      if (secretarias) {
        if (Array.isArray(secretarias)) {
          return (this.filtrosParametro.secretarias = secretarias.map(item => {
            return getValues(item)
          }))
        }

        this.filtrosParametro.secretarias.push(getValues(secretarias))
      }

      if (autarquias) {
        if (Array.isArray(autarquias)) {
          return (this.filtrosParametro.autarquias = autarquias.map(item => {
            return getValues(item)
          }))
        }

        this.filtrosParametro.autarquias = [...getValues(autarquias)]
      }
    },
    loadFiltros() {
      request
        .get('listar-filtros')
        .then(({ data }) => {
          const { secretarias } = data
          this.filtros.secretarias = secretarias
        })
        .catch(error => {
          const { response } = error
          if (response) {
            console.log(response)
          }

          this.$toastr.e(
            'Houve um erro ao carregar os filtros. Tente novamente'
          )
        })
    },
    salvarFavorito(codigo) {
      let objeto = JSON.parse(localStorage.getItem('pmsdadosabertos'))

      if (objeto) {
        let index = objeto.favoritos.indexOf(codigo)
        if (index === -1) {
          objeto.favoritos.push(codigo)
        } else {
          objeto.favoritos.splice(index, 1)
        }
      } else {
        objeto = { favoritos: [codigo] }
      }

      localStorage.setItem('pmsdadosabertos', JSON.stringify(objeto))
      this.$refs.dt.refresh()
      this.$toastr.s('Favoritos salvos com sucesso.')
    },
    classeFavoritos(codigo) {
      let objeto = JSON.parse(localStorage.getItem('pmsdadosabertos'))

      if (objeto && objeto.favoritos.indexOf(codigo) > -1) {
        return ['fas', 'star']
      }

      return ['far', 'star']
    },
    add(tipo, filtro) {
      if (tipo !== 'termo_pesquisa') {
        filtro.ativo = true
      } else {
        this.filtrosParametro[tipo] = null
      }

      if (this.filtrosParametro[tipo]) {
        this.filtrosParametro[tipo].push(filtro.codigo)
      } else {
        this.filtrosParametro[tipo] = [filtro.codigo]
      }

      window.history.pushState(
        null,
        null,
        '?' + formatObjectToQueryString(this.filtrosParametro)
      )
      this.$nextTick(() => {
        this.loadFiltros()
        this.$refs.dt.refresh()
      })
    }
  },
  computed: {
    idsArray() {
      return Object.keys(this.addDadoState).filter(
        codigo => this.addDadoState[codigo]
      )
    },
    secretariasFiltradas() {
      const filter = secr => {
        return this.filtrosParametro.secretarias.includes(secr.codigo)
      }

      return this.filtros.secretarias.filter(filter)
    },
    secretariasNaoFiltradas() {
      const filter = secr => {
        return !this.filtrosParametro.secretarias.includes(secr.codigo)
      }

      return this.filtros.secretarias.filter(filter)
    }
  }
}
</script>

<style scoped>
.btn-add {
  background: transparent;
  color: #468b35;
  border: 2px solid;
  border-radius: 6px;
}
.btn-add:hover,
.btn-add:focus {
  background: transparent;
  border: 2px solid;
  color: #a1be4d;
  text-transform: uppercase;
  box-shadow: none;
}
.btn-remove {
  text-shadow: 0 1px 0 #266c16;
  background: #468c36;
  color: #dae8d7;
  box-shadow: none;
  border-radius: 6px;
}
.btn-remove:focus,
.btn-remove:hover {
  background-color: #a1be4d;
  background-position: 0 -15px;
  color: #fff;
  border-radius: 6px;
}
.link-filtro {
  display: block;
  width: fit-content;
  padding: 5px 0;
}
.link-filtro > span {
  margin-left: 10px;
}
.link-filtro:not(:last-child) {
  border-bottom: 1px solid #e1e1e1;
}
.filtro-pesquisa input,
.filtro-pesquisa button {
  height: 50px;
  margin-bottom: 30px;
}
.filtro-pesquisa i {
  font-size: 1.3em;
}
</style>



// WEBPACK FOOTER //
// src/views/public/dados/PorSecretaria.vue